// features/user/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosPrivate } from '../hooks/axiosInstance';

// Generate new API key
export const generateApiKey = createAsyncThunk(
  'user/generateApiKey',
  async (_, thunkAPI) => {
    try {
      const response = await axiosPrivate.post('/admin/user/generate-api-key');
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { msg: error.message }
      );
    }
  }
);

// Get user profile (separate from auth - for settings page)
export const getUserProfile = createAsyncThunk(
  'user/getUserProfile',
  async (_, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/admin/user');
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { msg: error.message }
      );
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    profile: null,
    apiKey: null,
    apiKeyLoading: false,
    profileLoading: false,
    error: null,
    success: null,
    lastApiKeyGenerated: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
    clearApiKey: (state) => {
      state.apiKey = null;
      state.lastApiKeyGenerated = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Generate API Key
      .addCase(generateApiKey.pending, (state) => {
        state.apiKeyLoading = true;
        state.error = null;
      })
      .addCase(generateApiKey.fulfilled, (state, action) => {
        state.apiKeyLoading = false;
        state.success = action.payload.msg;
        state.apiKey = action.payload.apiKey;
        state.lastApiKeyGenerated = new Date().toISOString();
        
        // Update profile if it exists
        if (state.profile) {
          state.profile.apiKey = action.payload.apiKey;
        }
      })
      .addCase(generateApiKey.rejected, (state, action) => {
        state.apiKeyLoading = false;
        state.error = action.payload?.msg || 'Failed to generate API key';
      })

      // Get User Profile
      .addCase(getUserProfile.pending, (state) => {
        state.profileLoading = true;
        state.error = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = action.payload;
        
        // Set API key from profile if available
        if (action.payload.apiKey) {
          state.apiKey = action.payload.apiKey;
        }
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.error = action.payload?.msg || 'Failed to fetch user profile';
      });
  },
});

export const { clearMessages, clearApiKey } = userSlice.actions;

export default userSlice.reducer;